import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "./Footer.module.scss";
import { Link } from "react-router-dom";
import Image from "react-bootstrap/Image";
import logo from "../../images/logo.png";
import logoBlack from "../../images/logo-black.png";
import timbreMedia from "../../images/timbre-media.png";
import timbreMediaDark from "../../images/timbre-media-dark.png";
import { useDispatch, useSelector } from "react-redux";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/src/styles.scss";
import { AiFillCloseCircle } from "react-icons/ai";
import close from "../../styles/SuperAdminPanel.module.scss"
import { playerActions } from "../../store/playerSlice";

function Footer() {
  const theme = useSelector((state) => state.public.theme.selected);
  const player = useSelector((state) => state.player);
  const dispatch = useDispatch()
  return (
    <>
      {player.isPlaying && player.type === "audio" && (
        <AudioPlayer
          header={player.title}
          className="mt-4 px-5"
          autoPlay
          footer={
            <div
            onClick={() => {
              dispatch(playerActions.isPlaying(false));
            }}
              className={close.closeButton}
            >
              <AiFillCloseCircle />
            </div>
          }
          src={player.url}
          onPlay={(e) => 
            console.log("onPlay")
          }
        ></AudioPlayer>
      )}
      <footer className={`mt-auto ${styles.footer} mt-5`}>
        <Container>
          <Row className={`justify-content-between ${styles.row}`}>
            <Col md="12" lg="auto">
              <Image
                className={styles.footerLogo}
                src={theme === "dark" ? logoBlack : logo}
              />
            </Col>
            <Col className="mx-5">
              <h5>Company</h5>
              <ul>
                <li>
                  <Link to={"privacy"}>Privacy</Link>
                </li>
                <li>
                  <Link to={"contact-us"}>Contact Us</Link>
                </li>
              </ul>
            </Col>
            {/* <Col sm={6} md="auto" lg="auto">
              <h5>Media Center</h5>
              <ul>
                <li>
                  <Link to={"supported-devices"}>Supported Devices</Link>
                </li>
                <li>
                  <Link to={"manage-preferences"}>Manage Preferences</Link>
                </li>
              </ul>
            </Col>
            <Col sm={6} md="auto" lg="3">
              <h5>Need Help?</h5>
              <ul>
                <li>
                  <Link to={"help"}>Help</Link>
                </li>
                <li>
                  <Link to={"feedback"}>Feedback</Link>
                </li>
              </ul>
            </Col> */}
            <Col>
            <div
            className={`d-flex align-items-center justify-content-start justify-content-sm-end ${styles.poweredBy}`}
          >
            <span>Powered by</span>
            <Image
              className={styles.img}
              src={theme === "light" ? timbreMediaDark : timbreMedia}
            />
          </div>
          <div className="d-flex align-items-center justify-content-start justify-content-sm-end">
              {" "}
              <Image
                className={`${styles.img} mx-2 mb-2`}
                src="https://www.timbremedia.in/wp-content/themes/timbremedia-child/new/images/New-Project-45.png"
              />
            </div>
            </Col>
          </Row>
        </Container>
      </footer>{" "}
    </>
  );
}

export default Footer;
